import { dataAPI } from "./dataApi";

// Enhanced interface to include data source
interface ComponentWithSource {
    uid: string;
    name: string;
    slug: string;
    collection: string;
    fields: any[];
    showGroups?: boolean;
    public?: string;
    dataSource: 'mongodb';
    created?: string;
    updated?: string;
    createdBy?: string;
    _createdBy?: string;
    /** Present when the collection is visible to the user but owned by someone else (from GET /collections/components). */
    creatorDisplayName?: string;
    /** True when the foreign owner is a Labwick administrator (from GET /collections/components). */
    creatorIsAdmin?: boolean;
    /** Email of the collection owner when resolved (e.g. admin list). */
    creatorEmail?: string;
    /** Optional folder label for grouping this collection in menu navigation. */
    menuFolder?: string;
    /** Phosphor filled icon export name for the left menu (e.g. PiHouseFill). */
    menuIcon?: string;
    /** Present when data is served from an external connector. */
    source?: {
        kind: 'connector';
        connectorKey: string;
        remoteCollection?: string;
        /** True when served live from the connector without a Labwick import record. */
        live?: boolean;
    };
    /** Display label for the connector folder (from GET /collections/components). */
    connectorLabel?: string;
    /** Public asset base for connector pictures (e.g. https://veeninglab.com/rest). */
    connectorAssetPublicUrl?: string;
}

// Primary fetch function - the API returns MongoDB components
const fetchCollections = async (): Promise<ComponentWithSource[]> => {
    try {
        console.log('Fetching components from API...');

        // The API at /collections/components returns MongoDB components
        const response = await dataAPI.getComponents();
        console.log('🔍 API Response:', response);
        // Handle both response.data and response.components for backward compatibility
        const allComponents = response.data || response.components || [];
        console.log('📋 Extracted components:', allComponents);

        if (allComponents.length === 0) {
            console.warn("API returned no components");
            return [];
        }

        // Sort by name for consistent display
        allComponents.sort((a: ComponentWithSource, b: ComponentWithSource) =>
            (a.name || "").localeCompare(b.name || "")
        );

        const summary = {
            total: allComponents.length,
            mongodb: allComponents.filter((c: any) => c.dataSource === 'mongodb').length,
            source: 'api'
        };

        console.log('Components fetch summary:', summary);
        return allComponents as ComponentWithSource[];

    } catch (error) {
        console.error('API failed:', error);
        // API-only approach
        throw new Error("Failed to fetch components from API");
    }
};

// Export types
export type { ComponentWithSource };

// Export the default fetch function (API approach)
export default fetchCollections;